import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { submitAnswer } from '../../../utilities/Answer';
import { stopVoiceOutput } from '../../../services/shared';

export default function AiSuggestion() {
  const [isSuggestionSelected, setIsSuggestionSelected] = useState(false);
  const environment = useSelector((state: any) => state?.environment);
  const design = useSelector((state: any) => state?.design);
  const activeQuestion = environment?.activeQuestion;

  useEffect(() => {
    setIsSuggestionSelected(false);
  }, [activeQuestion.suggestions]);

  const send = (userInput: any) => {
    stopVoiceOutput();
    setIsSuggestionSelected(true);
    submitAnswer(userInput);
  }

  const generateKey = (pre: string, index: number) => {
    return `${ pre }_${ new Date().getTime() }_${index}`;
}

  return (
    <>
      {
        !isSuggestionSelected &&
        <div id='ele-286' className={`space-y-2 px-4 mt-2 max-h-72 overflow-hidden flex justify-end items-end flex-wrap`}>
          {
            (activeQuestion?.suggestions || []).map((suggestion: string, index: number) => (
              <button
                key={generateKey(suggestion, index)}
                className="ele-ai-suggestions-button flex ml-2 justify-end max-w-[80%] text-left text-sm" onClick={() => send(suggestion)}
              >
                <div className='ele-ai-suggestions-btn-text-container flex items-center py-1 px-3 border border-solid max-w-full text-sm border-primaryColor text-primaryColor cursor-pointer rounded-xl'>
                  <p className='ele-ai-suggestions-btn-text overflow-hidden w-full break-words' style={{ color: design.themeColor || '#226CF4' }}>{suggestion}</p>
                </div>
              </button>
            ))
          }
        </div>
      }
    </>
  );
}
